export const ASSETS = {
  TABS: {
    HARDENING: 'Hardening',
    APPLICATIONS: 'Aplicaciones',
  },
  PAGE_TITLES: {
    LAPTOPS: 'Portátiles',
    SERVERS: 'Servidores',
  },
  OS_NAMES: {
    MACOS: 'macOS',
    WINDOWS: 'Windows',
    LINUX: 'Linux',
    OS: 'SO',
  },
  OS_STATUS: {
    UPDATED: (osVersion: string) => `SO actualizado (${osVersion})`,
    SUPPORTED: (osVersion: string, latestVersion: string | null) =>
      latestVersion
        ? `SO soportado pero no en la última versión (Actual: ${osVersion}, Última: ${latestVersion})`
        : `SO soportado pero no en la última versión (${osVersion})`,
    PRE_RELEASE: (osVersion: string, latestVersion: string) =>
      `SO en una versión preliminar (${osVersion}). Fuera del proceso completo de seguridad. Estable recomendada: ${latestVersion}.`,
    OUTDATED: (osVersion: string, latestVersion: string | null) =>
      latestVersion
        ? `SO desactualizado y sin soporte (Actual: ${osVersion}  Última: ${latestVersion})`
        : `SO desactualizado y sin soporte (${osVersion})`,
    CHECKING: (osVersion: string) => `Comprobando estado del SO… (${osVersion})`,
  },
  LAPTOPS: {
    TITLE: 'Inventario de Portátiles',
    SEARCH_PLACEHOLDER: 'Buscar portátiles...',
    TABLE: {
      HOSTNAME: 'Endpoint',
      STATUS: 'Actualizaciones',
      OS: 'Sistema Operativo',
      HARDWARE: 'Hardware',
      ASSIGNED_TO: 'Owner',
      MDM_STATUS: 'Estado',
      ACTIONS: 'Acciones Rápidas',
      STATUS_INFO: {
        TITLE: 'Cómo se determina el estado de actualización',
        DESCRIPTION: [
          'Actualizado: el SO está en la última versión estable.',
          'Soportado: el SO aún está dentro de su ciclo de soporte pero no en la última versión estable.',
          'Desactualizado: la versión del SO ya no tiene soporte.',
          'Comprobando: el estado del SO se está evaluando.',
        ] as const,
      },
    },
    STATUS: {
      UPDATED: 'Actualizado',
      SUPPORTED: 'Soportado',
      OUTDATED: 'Desactualizado',
      CHECKING: 'Comprobando…',
    },
    MDM_STATUS: {
      MONITORED: 'Monitorizado',
      LOCKING: 'Bloqueando…',
      LOCKED: 'Bloqueado',
      UNLOCKING: 'Desbloqueando…',
      WIPE_REQUESTED: 'Borrado Solicitado',
      WIPING: 'Borrando…',
      WIPED: 'Borrado',
      TOOLTIP_MONITORED: 'Este dispositivo está siendo monitorizado por MDM',
      TOOLTIP_LOCKING: 'Comando de bloqueo en cola — esperando al dispositivo',
      TOOLTIP_LOCKED: 'Este dispositivo ha sido bloqueado remotamente por un administrador',
      TOOLTIP_UNLOCKING: 'Comando de desbloqueo en cola — esperando al dispositivo',
      TOOLTIP_WIPE_REQUESTED: 'Se ha enviado un comando de borrado remoto y está pendiente de ejecución',
      TOOLTIP_WIPING: 'Comando de borrado en cola — esperando al dispositivo',
      TOOLTIP_WIPED: 'Todos los datos de este dispositivo han sido borrados permanentemente',
    },
    SUMMARY: {
      LAPTOPS: 'portátiles',
    },
    UNASSIGNED: 'Sin Asignar',
    DRAWER: {
      SECTIONS: {
        OVERVIEW: 'Resumen',
        SYSTEM_DETAILS: 'Detalles del sistema',
        SECURITY: 'Seguridad',
      },
      FIELDS: {
        OS_STATUS: 'Estado del SO',
        OS: 'Sistema Operativo',
        OS_VERSION: 'Versión del SO',
        ARCHITECTURE: 'Arquitectura',
        SERIAL_NUMBER: 'Número de Serie',
        HARDWARE: 'Hardware',
        MDM_STATUS: 'Estado MDM',
        EDR_AGENT: 'Agente EDR',
        LAST_SEEN: 'Última Conexión',
        ASSIGNED_TO: 'Asignado a',
      },
      MDM: {
        REMOTE_WIPE: 'Borrado Remoto',
        REMOTE_LOCK: 'Bloqueo Remoto',
        REMOTE_WIPE_DESCRIPTION:
          'Borrar permanentemente todos los datos de este dispositivo. Esta acción no se puede deshacer.',
        REMOTE_WIPE_CONFIRMATION_TITLE: 'Borrado Remoto de',
        REMOTE_WIPE_CONFIRMATION_DESCRIPTION: 'Esto borrará permanentemente todos los datos en este dispositivo.',

        REMOTE_WIPE_CONFIRMATION_DESCRIPTION_IRREVERSIBLE: 'Esta acción no se puede revertir',
        REMOTE_WIPE_CONFIRMATION_LABEL_PREFIX: 'Escribe',
        REMOTE_WIPE_CONFIRMATION_LABEL_SUFFIX: 'para confirmar',
        REMOTE_WIPE_CONFIRM_BUTTON: 'Borrar Dispositivo',
        REMOTE_WIPE_CANCEL_BUTTON: 'Cancelar',
        REMOTE_WIPE_SUCCESS: (hostname: string) => `Comando de borrado remoto enviado a ${hostname}`,
        REMOTE_WIPE_ERROR: (hostname: string) => `Error al borrar ${hostname}`,
        REMOTE_WIPE_SENDING_COMMAND: 'Enviando comando de borrado...',
        REMOTE_WIPE_WARNING: {
          TITLE: 'Borrado Remoto de',
          HEADING: 'Estás a punto de borrar permanentemente este dispositivo.',
          ITEM_ALL_DATA_PREFIX: 'Todos los datos serán ',
          ITEM_ALL_DATA_HIGHLIGHT: 'destruidos permanentemente',
          ITEM_ALL_DATA_SUFFIX: '.',
          ITEM_NO_RECOVERY: 'No hay opción de recuperación.',
          FINAL_WARNING: 'Esta acción no se puede deshacer. Procede solo si estás absolutamente seguro.',
          CANCEL_BUTTON: 'Cancelar',
          CONTINUE_BUTTON: 'OK, lo entiendo',
        },
        REMOTE_LOCK_CONFIRMATION_TITLE: 'Bloqueo Remoto de',
        REMOTE_LOCK_CONFIRMATION_DESCRIPTION: 'Esto bloqueará inmediatamente el dispositivo.',
        REMOTE_LOCK_CONFIRMATION_DESCRIPTION_REQUIRES_PIN:
          'Esto bloqueará inmediatamente el dispositivo, requiriendo un código para desbloquearlo.',
        REMOTE_LOCK_CONFIRM_BUTTON: 'Bloquear Dispositivo',
        REMOTE_LOCK_SENDING_COMMAND: 'Enviando comando de bloqueo..',
        REMOTE_LOCK_CANCEL_BUTTON: 'Cancelar',
        REMOTE_LOCK_SUCCESS: (hostname: string) => `Comando de bloqueo remoto enviado a ${hostname}`,
        REMOTE_LOCK_ERROR: (hostname: string) => `Error al bloquear ${hostname}`,
        UNLOCK_BUTTON: 'Desbloquear Dispositivo',
        UNLOCK_SUCCESS: (hostname: string) => `Comando de desbloqueo enviado a ${hostname}`,
        UNLOCK_ERROR: (hostname: string) => `Error al desbloquear ${hostname}`,
        UNLOCK_PIN_TITLE: (hostname: string) => `PIN de desbloqueo para ${hostname}`,
        UNLOCK_PIN_DESCRIPTION: 'Introduce este PIN en el dispositivo para desbloquearlo.',
        UNLOCK_PIN_COPY_BUTTON: 'Copiar PIN',
        UNLOCK_PIN_COPIED: 'PIN copiado al portapapeles',
        UNLOCK_PIN_CLOSE_BUTTON: 'Cerrar',
        TOOLTIP_LOCK: 'Bloquear dispositivo',
        TOOLTIP_UNLOCK: 'Desbloquear dispositivo',
        TOOLTIP_WIPE: 'Borrar dispositivo',
      },
    },
  },
  SERVERS: {
    TITLE: 'Inventario de Servidores',
    SEARCH_PLACEHOLDER: 'Buscar servidores...',
    TABLE: {
      HOSTNAME: 'Endpoint',
      STATUS: 'Estado',
      OS: 'Sistema Operativo',
      HARDWARE: 'Hardware',
      STATUS_INFO: {
        TITLE: 'Cómo se determina el estado de actualización',
        DESCRIPTION: [
          'Actualizado: el SO está en la última versión estable.',
          'Soportado: el SO aún está dentro de su ciclo de soporte pero no en la última versión estable.',
          'Desactualizado: la versión del SO ya no tiene soporte.',
          'Comprobando: el estado del SO se está evaluando.',
        ] as const,
      },
    },
    SUMMARY: {
      SERVERS: 'servidores',
    },
    DRAWER: {
      SECTIONS: {
        OVERVIEW: 'Resumen',
        SYSTEM_DETAILS: 'Detalles del sistema',
        SECURITY: 'Seguridad',
      },
      FIELDS: {
        OS_STATUS: 'Estado del SO',
        OS: 'Sistema Operativo',
        OS_VERSION: 'Versión del SO',
        ARCHITECTURE: 'Arquitectura',
        SERIAL_NUMBER: 'Número de Serie',
        HARDWARE: 'Hardware',
        EDR_AGENT: 'Agente EDR',
        LAST_SEEN: 'Última Conexión',
      },
    },
  },
  APPLICATIONS: {
    SEARCH_PLACEHOLDER: 'Buscar aplicaciones...',
    FILTER: {
      ALL: 'Todas',
      APPROVED: 'Aprobadas',
      DENIED: 'Rechazadas',
      PENDING: 'Pendientes de Revisión',
    },
    TABLE: {
      HOSTNAME: 'Endpoint',
      OS: 'Sistema Operativo',
      TOTAL_APPS: 'Aplicaciones',
      PENDING_REVIEW: 'Pendientes de Revisión',
      APPROVED: 'Aprobadas',
      DENIED: 'Rechazadas',
    },
    DRAWER: {
      UTILITY: 'Utilidad',
      TITLE: 'Aplicaciones',
      SUMMARY: 'Resumen de Estado de Apps',
      NO_APPS: 'No se encontraron aplicaciones',
      HIDE_UTILITIES: 'Ocultar utilidades',
      FIELDS: {
        SOFTWARE_NAME: 'Nombre del Software',
        VENDOR: 'Proveedor',
        VERSION: 'Versión',
        PLATFORM: 'Plataforma',
        STATUS: 'Estado',
      },
      STATUS: {
        APPROVED: 'Aprobada',
        DENIED: 'Rechazada',
        PENDING_REVIEW: 'Pendiente de Revisión',
      },
      EXTENDED_INFO: {
        FORMAT: 'Formato',
        BUNDLE_ID: 'ID de Bundle',
        LOCATION: 'Ubicación',
      },
      STATUS_UPDATED: 'Estado de aplicación actualizado correctamente',
      SUMMARY_COUNTS: {
        TOTAL_APPS: 'aplicaciones',
        APPROVED: 'aprobadas',
        DENIED: 'rechazadas',
        PENDING_REVIEW: 'pendientes de revisión',
      },
    },
  },
} as const
